import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json' with { type: 'json' };
import de from './locales/de.json' with { type: 'json' };
import it from './locales/it.json' with { type: 'json' };
import fr from './locales/fr.json' with { type: 'json' };
import pl from './locales/pl.json' with { type: 'json' };
import ro from './locales/ro.json' with { type: 'json' };

export const PERSIST_STORAGE_KEY = 'pizza-belag';
const SUPPORTED_CODES = ['en', 'de', 'it', 'fr', 'pl', 'ro'];

export function resolveBrowserLanguage() {
  const browser = (typeof navigator !== 'undefined' && navigator.language || 'en').toLowerCase().split('-')[0];
  return SUPPORTED_CODES.includes(browser) ? browser : 'en';
}

function resolveInitialLanguage() {
  if (typeof window === 'undefined') {
    return resolveBrowserLanguage();
  }
  try {
    const stored = JSON.parse(window.localStorage.getItem(PERSIST_STORAGE_KEY));
    const language = stored?.state?.language;
    if (SUPPORTED_CODES.includes(language)) return language;
  } catch {
    /* localStorage unavailable or no persisted language */
  }
  return resolveBrowserLanguage();
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
    it: { translation: it },
    fr: { translation: fr },
    pl: { translation: pl },
    ro: { translation: ro },
  },
  lng: resolveInitialLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng;
  }
});

export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', native: 'English', flag: '🇬🇧' },
  { code: 'de', name: 'German', native: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', name: 'Italian', native: 'Italiano', flag: '🇮🇹' },
  { code: 'fr', name: 'French', native: 'Français', flag: '🇫🇷' },
  { code: 'pl', name: 'Polish', native: 'Polski', flag: '🇵🇱' },
  { code: 'ro', name: 'Romanian', native: 'Română', flag: '🇷🇴' },
];

export default i18n;
